// extracted by mini-css-extract-plugin
module.exports = {"root":"RingtoneDeviceSelect_root__3OsCg"};